/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropEnrollmentRequest
 */
export interface DropEnrollmentRequest {
    /**
     * 
     * @type {any}
     * @memberof DropEnrollmentRequest
     */
    dropDate: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof DropEnrollmentRequest
     */
    approveScheduledDrop?: boolean;
}

/**
 * Check if a given object implements the DropEnrollmentRequest interface.
 */
export function instanceOfDropEnrollmentRequest(value: object): value is DropEnrollmentRequest {
    if (!('dropDate' in value) || value['dropDate'] === undefined) return false;
    return true;
}

export function DropEnrollmentRequestFromJSON(json: any): DropEnrollmentRequest {
    return DropEnrollmentRequestFromJSONTyped(json, false);
}

export function DropEnrollmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropEnrollmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dropDate': json['dropDate'],
        'approveScheduledDrop': json['approveScheduledDrop'] == null ? undefined : json['approveScheduledDrop'],
    };
}

export function DropEnrollmentRequestToJSON(json: any): DropEnrollmentRequest {
    return DropEnrollmentRequestToJSONTyped(json, false);
}

export function DropEnrollmentRequestToJSONTyped(value?: DropEnrollmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dropDate': value['dropDate'],
        'approveScheduledDrop': value['approveScheduledDrop'],
    };
}

